<template>
  <a-upload
    :custom-request="customRequest"
    @change="handleChange"
    v-model:file-list="fileList"
    :remove="removeFile"
  >
    <a-button v-if="fileList.length === 0" :disabled="props.disabled">
      <upload-outlined></upload-outlined>
      上传文件
    </a-button>
  </a-upload>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { UploadOutlined } from "@ant-design/icons-vue";
import { uploadRNDDataLib, deleteFile } from "@/request/view/project";

export default defineComponent({
  components: { UploadOutlined },
  props: {
    echoFile: String,
    disabled: Boolean,
    action: Object,
  },
  setup(props, context) {
    const fileList = ref([]);

    const handleChange = ({ file, fileList }) => {
      if (file.status !== "uploading") {
        console.log(file, fileList);
      }
    };

    const setUploadFileUrl = (url) => {
      context.emit("setUploadFileUrl", url);
    };

    const removeFile = (file) => {
      if (file.url) {
        deleteFile([file.url])
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      setUploadFileUrl(null);
    };

    const customRequest = (file) => {
      const formData = new FormData();
      formData.append("file", file.file);

      let reqFn = uploadRNDDataLib;

      if (props.action) {
        reqFn = props.action;
      }

      reqFn(formData)
        .then((res) => {
          fileList.value[0].status = "done";
          setUploadFileUrl(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const getSuffixName = (str) => {
      const lastSlash = str.split("").findLastIndex((item) => item === "/");
      if (lastSlash !== -1) {
        return str.slice(lastSlash + 1);
      }
      return "";
    };
    watch(
      () => props.echoFile,
      (val) => {
        fileList.value.length = 0;
        if (val) {
          fileList.value.push({
            status: "done",
            name: getSuffixName(val),
            url: val,
          });
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      fileList,
      removeFile,
      setUploadFileUrl,
      customRequest,
      handleChange,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
